import { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

let pluginsRegistered = false;

if (typeof window !== 'undefined' && !pluginsRegistered) {
  gsap.registerPlugin(ScrollTrigger);
  pluginsRegistered = true;
}

const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const useHeroReveal = (rootRef, deps = []) => {
  useEffect(() => {
    if (!rootRef?.current || prefersReducedMotion()) return undefined;

    const ctx = gsap.context(() => {
      const heroItems = gsap.utils.toArray('[data-hero-item]');
      if (!heroItems.length) return;

      gsap.fromTo(
        heroItems,
        { autoAlpha: 0, y: 28 },
        {
          autoAlpha: 1,
          y: 0,
          duration: 1.06,
          ease: 'power3.out',
          stagger: 0.14,
          delay: 0.28
        }
      );
    }, rootRef);

    return () => ctx.revert();
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
};

export const useScrollReveal = (rootRef, deps = []) => {
  useEffect(() => {
    if (!rootRef?.current || prefersReducedMotion()) return undefined;

    const ctx = gsap.context(() => {
      const singleItems = gsap.utils.toArray('[data-reveal]');
      singleItems.forEach((item) => {
        gsap.fromTo(
          item,
          { autoAlpha: 0, y: 28 },
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.98,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: item,
              start: 'top 88%',
              once: true
            }
          }
        );
      });

      const staggerGroups = gsap.utils.toArray('[data-stagger]');
      staggerGroups.forEach((group) => {
        const items = group.querySelectorAll('[data-stagger-item]');
        if (!items.length) return;

        gsap.fromTo(
          items,
          { autoAlpha: 0, y: 26 },
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.92,
            ease: 'power2.out',
            stagger: 0.12,
            scrollTrigger: {
              trigger: group,
              start: 'top 84%',
              once: true
            }
          }
        );
      });
    }, rootRef);

    return () => ctx.revert();
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
};
